import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PhotoContainer from '../PhotoContainer';
import EditMember from './EditMember';
import { getRoleNames } from '../../utils';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class Member extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openEditModal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (this.props.status !== status) {
      if (status === actionTypes.MEMBER_UPDATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    }
  }

  onClick(e) {
    e.preventDefault();

    this.setState({ openEditModal: true });
  }

  handleCloseModal() {
    this.setState({ openEditModal: false });
  }

  handleSaveMember(data) {
    const { team, member } = this.props;

    this.props.hideAlert();

    if (team) {
      this.props.updateUser({
        id: member.user,
        name: data.name,
        avatar: data.avatar,
        company_name: data.company_name,
        user_title: data.user_title,
        use_company_name: data.use_company_name,
        username: member.user_info.username,
      });

      this.props.updateMember({
        id: member.id,
        user: member.user,
        team: team.id,
        role_ids: data.role_ids,
      });

      if (member.ownership) {
        if (
          member.ownership.ownership_type !==
          parseInt(data.ownership_type_id, 10)
        ) {
          this.props.deleteOwnership({
            id: member.ownership.id,
            team: team.id,
            team_user: member.id,
          });
        }
      }

      if (data.ownership_type_id) {
        if (
          !member.ownership ||
          (member.ownership &&
            member.ownership.ownership_type !==
              parseInt(data.ownership_type_id, 10))
        ) {
          this.props.createOwnership({
            team: team.id,
            team_user: member.id,
            ownership_type: data.ownership_type_id,
            percentage: 0,
          });
        }
      }
    } else {
      const member = {
        user_info: {
          email: data.email,
          name: data.name,
          avatar: data.avatar,
          company_name: data.company_name,
          user_title: data.user_title,
          use_company_name: data.use_company_name,
        },
        role_ids: data.role_ids,
        ownership_type_id: data.ownership_type_id,
      };
      this.props.saveMember(member);
    }
  }

  handleDeleteMember() {
    const { member, team } = this.props;

    if (team) this.props.deleteMember(member);
    else this.props.removeMember(member);
  }

  render() {
    const { member, roles } = this.props;
    const roleNames = getRoleNames(member.role_ids, roles);
    const companyName = member.user_info.use_company_name
      ? member.user_info.company_name
      : '';

    return (
      <div className="member" onClick={(e) => this.onClick(e)}>
        <Row>
          <Col md={3} className="member-photo">
            <PhotoContainer
              className="photo-container"
              image={member.user_info.avatar}
              defaultImg="user"
            />
          </Col>
          <Col md={9} className="member-text">
            <p>
              {member.user_info.name}&nbsp;
              {companyName ? `(${companyName})` : ''}
            </p>
            <p className="text-gray">{member.user_info.email}</p>
            <p className="text-gray">{roleNames.join(', ')}</p>
          </Col>
        </Row>
        <EditMember
          member={member}
          open={this.state.openEditModal}
          onClose={() => this.handleCloseModal()}
          onSave={(data) => this.handleSaveMember(data)}
          onDelete={() => this.handleDeleteMember()}
          type={this.props.type}
          profile={this.props.profile}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  roles: state.global.roles,
  team: state.teams.selectedTeam,
  status: state.users.status,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  saveMember: (member) => {
    dispatch(actions.saveTeamMember(member));
  },
  removeMember: (member) => {
    dispatch(actions.removeTeamMember(member));
  },
  updateMember: (member) => {
    dispatch(actions.updateTeamMember(member));
  },
  deleteMember: (member) => {
    dispatch(actions.deleteTeamMember(member));
  },
  updateUser: (user) => {
    dispatch(actions.updateUser(user));
  },
  createOwnership: (ownership) => {
    dispatch(actions.createMemberOwnership(ownership));
  },
  deleteOwnership: (ownership) => {
    dispatch(actions.deleteMemberOwnership(ownership));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Member);



// WEBPACK FOOTER //
// src/components/Members/Member.jsx